module.exports = __webpack_public_path__ + "static/img/nrzd.cbaff0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kpi/nrzd.png
// module id = bUUQ
// module chunks = 12